import { Suspense, lazy } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import Loading from '../components/Loading';
import publicRoute from './public'; // 不需要权限的页面
import homeRoute from './home'; // 首页
import listRoute from './reportList';  // 报表列表
import aggregateConfigRoute from './overview';//预览页面
import systemDirectoryRoute from './systemDirectory';//系统目录
import reportAuthorityRoute from './reportAuthorityDetails';//报表权限明细
import dataPreprocessingRoute from './dataPreprocessing';//报表权限明细
import tweetRoute from './tweet';//报表权限明细
import aiRoute from './ai';//报表权限明细
const App = lazy(() => import('@layouts/App'));

export const routes: Array<RouteConfig> = [
    ...homeRoute,
    ...listRoute,
    ...aggregateConfigRoute,
    ...systemDirectoryRoute,
    ...reportAuthorityRoute,
    ...dataPreprocessingRoute,
    ...tweetRoute,
    ...aiRoute
];
const Router = () => {
    return (
        <HashRouter>
            <Suspense fallback={ <Loading type="fullscreen"/> }>
                <Switch>
                    {
                        publicRoute.map((route, i) => (
                            <Route
                                key={i}
                                path={route.path}
                                exact={true}
                                component={ route.component }
                            />
                        ))
                    }
                    <Route path="/" render= { routeProps => (
                        <App {...routeProps} routes={ routes }/>
                    )}/>
                </Switch>
            </Suspense>
        </HashRouter>
    )
}
export default Router